module.exports = __webpack_public_path__ + "static/img/baojing.b4422a16.png";